import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";

const OnboardingSurveyFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);

  if (flow?.isCompleted) {
    return (
      <Frigade.Survey.NPS
        flowId={config.frigade.flows.onboardingSurvey}
        dismissible={true}
      />
    );
  }
};

export default OnboardingSurveyFlow;
